import { Swiper } from 'swiper';
import { Navigation, A11y } from 'swiper/modules';
import 'swiper/css';

const sectionFolderSliders = document.querySelectorAll('section.folder-slider');

/**
 * Mark the middle visible slides as featured (larger).
 *
 * @param {import('swiper').Swiper} swiper
 */
const updateFeaturedSlides = (swiper) => {
	const slidesPerView = swiper.params.slidesPerView;
	const visibleCount = typeof slidesPerView === 'number' ? Math.floor(slidesPerView) : 1;
	const slideCount = swiper.slides.length;

	let featuredStart = swiper.activeIndex;
	let featuredEnd = swiper.activeIndex;

	if (visibleCount >= 3) {
		featuredStart = swiper.activeIndex + 1;
		featuredEnd = featuredStart + 1;
	} else if (visibleCount >= 2) {
		featuredEnd = featuredStart + 1;
	}

	featuredStart = Math.min(featuredStart, Math.max(slideCount - 1, 0));
	featuredEnd = Math.min(featuredEnd, Math.max(slideCount - 1, 0));

	swiper.slides.forEach((slide, index) => {
		const isFeatured = index >= featuredStart && index <= featuredEnd;
		slide.classList.toggle('is-featured', isFeatured);
	});
};

/**
 * Update the "x of y" counter.
 *
 * @param {import('swiper').Swiper} swiper
 * @param {HTMLElement} counterEl
 */
const updateCounter = (swiper, counterEl) => {
	if (!counterEl) {
		return;
	}

	const currentEl = counterEl.querySelector('.current');
	if (currentEl) {
		currentEl.textContent = String(swiper.realIndex + 1);
	}
};

document.addEventListener('DOMContentLoaded', () => {
	sectionFolderSliders.forEach((section) => {
		if (!section.querySelector('.swiper-folder-slider')) {
			return;
		}

		const sectionId = section.getAttribute('id');
		const swiperId = `#${sectionId} .swiper-folder-slider`;
		const counterEl = section.querySelector('.folder-slider-counter');

		const swiper = new Swiper(swiperId, {
			watchSlidesProgress: true,
			modules: [Navigation, A11y],
			a11y: true,
			grabCursor: true,
			loop: true,
			slidesPerView: 1.25,
			spaceBetween: 16,
			speed: 450,
			keyboard: {
				enabled: true,
			},
			navigation: {
				nextEl: `#${sectionId} .swiper-btn-next`,
			},
			breakpoints: {
				640: {
					slidesPerView: 2.25,
				},
				1024: {
					slidesPerView: 3.5,
				},
				1280: {
					slidesPerView: 4,
					spaceBetween: 16,
				},
			},
			on: {
				init(instance) {
					updateFeaturedSlides(instance);
					updateCounter(instance, counterEl);
				},
				slideChange(instance) {
					updateFeaturedSlides(instance);
					updateCounter(instance, counterEl);
				},
				resize(instance) {
					updateFeaturedSlides(instance);
				},
				breakpoint(instance) {
					updateFeaturedSlides(instance);
				},
			},
		});

		return swiper;
	});
});
